import React from 'react';
import { withRouter } from 'react-router-dom';
import 'assets/sass/style.scss';

const PublicHeader = (props) => {
   return (
      <header className="main_header">
         <nav className="theme_navigation navbar login_nav">
            <a className="logo" href="/">
               <img
                  src={require('assets/images/thumbnails/logo.png')}
                  alt="InHarmony Web Logo"
                  className="header__logo"
               />
            </a>
         </nav>
      </header>
   );
};

const PublicFooter = () => {
   var d = new Date();
   let year = d.getFullYear();
   return (
      <footer className="main_footer wow fadeIn">
         <div className="link_list_group">
            <span className="ph_textcopy footer_link">
               © {year} inHarmony, Inc. All rights reserved |{' '}
               <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="mailto:help@iaminharmony.com?subject=Support - inHarmony: Music Meditations Web App"
               >
                  Contact Support
               </a>
            </span>
         </div>
      </footer>
   );
};

class PublicLayout extends React.Component {
   render() {
      return (
         <>
            <div className="limiter">
               <div className="container-login100">
                  <PublicHeader {...this.props} />
                  {this.props.children}
                  <PublicFooter {...this.props} />
               </div>
            </div>
         </>
      );
   }
}

export default withRouter(PublicLayout);
